export default class UserViewmodel {
    public id: string = '';
    public firstName: string = '';
    public lastName: string = '';
    public email: string = '';
    public phoneNumber: string = '';
    public userTypeId: number = 0;
    public clientId: number = 0;
    public signature?: File[] | null = null;
}